{
  "zh-TW": {
    "nav": {
      "home": "首頁",
      "back": "返回",
      "navigation": "導航",
      "ships": {
        "index": "飛船"
      },
      "compare": {
        "index": "比較",
        "ships": "比較飛船"
      },
      "manufacturers": "製造商",
      "images": "圖片",
      "videos": "影片",
      "hangar": {
        "index": "我的機庫",
        "vehicleLoadouts": "Loadouts"
      },
      "login": "登入",
      "logout": "登出",
      "apiV1": "API v1",
      "apiV1Schema": "架構",
      "apiV1Pagination": "分頁",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "架構",
      "embed": "嵌入小工具",
      "signUp": "註冊",
      "privacyPolicy": "隱私政策",
      "impressum": "法律聲明",
      "fleets": {
        "index": "艦隊",
        "add": "建立新艦隊",
        "invites": "邀請",
        "ships": "飛船",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "世界地圖",
          "starmap": "星圖"
        },
        "stats": "統計",
        "logistics": {
          "index": "Logistics"
        },
        "settings": {
          "index": "設定",
          "fleet": "艦隊設定",
          "membership": "成員設定",
          "roles": "角色"
        }
      },
      "rsiProfile": "RSI 檔案",
      "rsiHangar": "RSI 機庫",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行時間",
        "cargoGrids": "貨物網格"
      },
      "api": "API 文件",
      "stats": "統計",
      "toggleSlimCollapse": "摺疊",
      "toggleSlimExpand": "展開",
      "roadmap": {
        "index": "路線圖",
        "overview": "概覽",
        "changes": "變更",
        "ships": "飛船路線圖"
      },
      "rsiVerification": "RSI 驗證",
      "settings": {
        "index": "設定",
        "profile": "檔案",
        "account": "帳戶",
        "security": "安全",
        "notifications": "通知",
        "hangar": "機庫",
        "features": "功能",
        "connections": "連線",
        "oauthApplications": "OAuth 應用",
        "verify": "RSI 帳戶驗證"
      },
      "reload": "有可用更新！",
      "visualTests": {
        "index": "視覺測試",
        "panels": "面板",
        "buttons": "按鈕",
        "tables": "表格",
        "notifications": "通知",
        "syncModal": "同步彈窗",
        "supportHint": "支援提示"
      },
      "admin": {
        "index": "管理員",
        "models": {
          "index": "模型",
          "create": "建立模型",
          "edit": {
            "index": "基礎資料",
            "metrics": "指標",
            "prices": "價格",
            "docks": "停靠點",
            "modules": "模組",
            "paints": "塗裝",
            "images": "圖片",
            "videos": "影片",
            "cargoAndFuel": "貨物和燃料",
            "cargoHolds": "貨艙",
            "fleetchart": "艦隊圖表圖片",
            "hardpoints": "武器掛點",
            "loaners": "借用船",
            "upgrades": "升級",
            "packages": "套餐"
          }
        },
        "modelPaints": {
          "index": "塗裝",
          "create": "建立塗裝"
        },
        "modelModules": {
          "index": "模組",
          "create": "建立模組",
          "edit": {
            "index": "基本資料",
            "models": "模型",
            "prices": "價格"
          }
        },
        "modelModulePackages": {
          "index": "模組包",
          "create": "建立模組包"
        },
        "components": {
          "index": "組件",
          "edit": {
            "index": "基礎資料",
            "prices": "價格"
          }
        },
        "manufacturers": {
          "index": "製造商"
        },
        "images": {
          "index": "圖片"
        },
        "users": {
          "index": "使用者"
        },
        "fleets": {
          "index": "艦隊"
        },
        "vehicles": {
          "index": "載具"
        },
        "admins": {
          "index": "管理員"
        },
        "oauthApplications": {
          "index": "OAuth 應用"
        },
        "maintenance": {
          "index": "維護",
          "pghero": "PG-Hero",
          "features": "功能",
          "workers": "工作程序",
          "tasks": "任務",
          "rsiApiStatus": "RSI API 狀態"
        },
        "supporterContributions": {
          "index": "支持者貢獻",
          "new": "新增支持者貢獻",
          "edit": "編輯支持者貢獻"
        },
        "fundingGoals": {
          "index": "資金目標",
          "new": "新增資金目標",
          "edit": "編輯資金目標"
        }
      }
    }
  }
}
